// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3Yjio","clinicsSelect":"TableHeading_clinicsSelect__1d8Ob"};